module.exports = __webpack_public_path__ + "img/no-user.7dfebd4e.jpg";